<template>
    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Modal title</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="card-body">
                            <div class="form-group row">
                                <label for="card-num" class="col-md-4 col-form-label text-md-right">Card Number</label>

                                <div class="col-md-6">
                                    <input id="card-num" type="text" class="form-control" v-model="card_no" required autofocus>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">


                                </div>

                            </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary" @click="handleSubmit">
                        Register
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddCardComponent',
    data(){
        return {
            user: {},
            card_no:'',
        }
    },
    methods : {


        handleSubmit(e) {
            e.preventDefault();

            if (true) {
                axios.post(this.apiEndPoints.registerCard, {
                    card_no: this.card_no,
                })
                .then(response => {
                    // console.log(response);

                    if(response.data && response.data.status) {

                        if(response.data.status == 'success') {

                            if(response.data.user && response.data.user.id) {
                                this.resetUserInLocalStorage(response.data.user);
                                this.user = response.data.user;
                            }
                        } else if(response.data.message) {
                            this.errors.push(response.data.message)
                        } else {
                            this.errors.push('An error occurred. Please try again!')
                        }
                    }
                })
                .catch(error => {
                    console.error(error.response);

                    if(error.response && error.response.status && error.response.status == 419) {
                        this.$router.push({ name: 'sign_in' });
                    }
                });
            }
        }
    }
}
</script>
